import { Link } from "react-router-dom";

import type { FilesStatus } from "../../../api/types";
import { filesStatusWords } from "../../../app/StatusBar";
import { useLive } from "../../../live/store";
import { Pill } from "../../../ui";

/**
 * The state of the discipline's files: up to date at which change, being written, or failed with the reason.
 * The live channel has the newest word; the home answer is used until it has spoken.
 */
export function FilesLine({ status }: { status: FilesStatus | null | undefined }) {
  const live = useLive();
  const current = live.files ?? status;
  if (!current) return null;
  const failed = current.status === "check_failed";
  const named = current.elements?.length ?? 0;
  return (
    <p className="nv-files" data-status={current.status}>
      <span className="muted">Files: </span>
      <Pill tone={failed ? "problem" : "neutral"}>{filesStatusWords(current)}</Pill>
      {failed && current.message && <span className="nv-files__why"> {current.message}</span>}
      {failed && named > 0 && (
        <span className="muted">
          {" "}
          {named === 1 ? "1 element is" : `${named} elements are`} named in the files view.
        </span>
      )}{" "}
      <Link to="/files">Open the files view</Link>
    </p>
  );
}
